import React from 'react';
import { Grid as GridIcon, Thermometer, Fan } from 'lucide-react';
import { GridCell } from '../types';

interface EditorCellProps {
  cell: GridCell;
  rowIndex: number;
  colIndex: number;
  onClick: (row: number, col: number) => void;
}

const EditorCell: React.FC<EditorCellProps> = ({ cell, rowIndex, colIndex, onClick }) => {
  const baseClasses = 'w-12 h-12 flex items-center justify-center rounded cursor-pointer';
  const typeClass =
    cell.type === 'empty' ? 'bg-gray-700 hover:bg-gray-600'
    : cell.type === 'rack' ? (cell.locked ? 'bg-blue-900' : 'bg-blue-600')
    : cell.type === 'cooling' ? 'bg-cyan-600'
    : cell.type === 'hot-aisle' ? 'bg-red-700'
    : cell.type === 'cold-aisle' ? 'bg-blue-700'
    : cell.type === 'power' ? 'bg-yellow-600'
    : cell.type === 'networking' ? 'bg-purple-600'
    : '';

  return (
    <div
      onClick={() => onClick(rowIndex, colIndex)}
      className={`${baseClasses} ${typeClass}`}
    >
      {cell.type !== 'empty' && (
        <div className="text-xs text-white opacity-75">
          {cell.type === 'rack' && <GridIcon className="w-6 h-6" />}
          {cell.type === 'cooling' && <Fan className="w-6 h-6" />}
          {cell.type === 'hot-aisle' && <Thermometer className="w-6 h-6" />}
          {cell.type === 'cold-aisle' && <Thermometer className="w-6 h-6" />}
          {cell.type === 'power' && '⚡'}
          {cell.type === 'networking' && '🌐'}
        </div>
      )}
    </div>
  );
};

export default React.memo(EditorCell);
